import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首頁", to: "/" },
  { label: "全省服務據點", to: "/locations" },
  { label: "自地自建講座", to: "/seminars" },
  { label: "作品介紹", to: "/portfolio" },
  { label: "集團品牌介紹", to: "/about" },
  { label: "服務流程與收費", to: "/process" },
  { label: "線上諮詢", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-graphite text-cream">
      <div className="container-main px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/c9f63e4dcd1d918f048871dce3e78869.png"
                alt="速築美宅家"
                className="h-10 w-auto brightness-200"
              />
            </div>
            <p className="text-cream/80 text-base mb-2">速築之道，研質生活</p>
            <p className="text-light-gray text-base">台北｜新竹｜台中｜台南｜屏東｜全省服務</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-base font-bold mb-5 text-champagne">快速連結</h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-cream/70 text-base hover:text-champagne transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-base font-bold mb-5 text-champagne">聯絡資訊</h4>
            <p className="text-cream/70 text-base mb-3">LINE@：@580frsef</p>
            <a
              href="https://lin.ee/OpssTIM"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-champagne hover:text-champagne/80 transition-colors text-base font-medium"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-line-fill" />
              </span>
              加入 LINE 諮詢
            </a>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-serif text-base font-bold mb-5 text-champagne">訂製建築諮詢</h4>
            <p className="text-cream/60 text-base mb-4">歡迎加入 LINE，免費預約自地自建與危老重建諮詢。</p>
            <a
              href="https://lin.ee/OpssTIM"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-base w-full justify-center gap-2"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-line-fill" />
              </span>
              加入 LINE 諮詢
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-cream/10">
        <div className="container-main px-4 md:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-cream/40 text-base">© 速築美宅家 Chronos Space. All rights reserved.</p>
          <p className="text-cream/40 text-base">
            LINE@：<a href="https://lin.ee/OpssTIM" target="_blank" rel="noopener noreferrer" className="text-champagne hover:underline">@580frsef</a>
          </p>
        </div>
        <div className="container-main px-4 md:px-8 lg:px-12 pb-5 text-center">
          <p className="text-cream/20 text-sm">
            品牌官網建置｜<a href="https://vpivip.com/" target="_blank" rel="noopener noreferrer" className="hover:text-cream/40 transition-colors">天地人網整合行銷</a>
          </p>
        </div>
      </div>
    </footer>
  );
}